"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
__exportStar(require("./index"), exports);
__exportStar(require("./css-color-names"), exports);
__exportStar(require("./readability"), exports);
__exportStar(require("./to-ms-filter"), exports);
__exportStar(require("./from-ratio"), exports);
__exportStar(require("./format-input"), exports);
__exportStar(require("./random"), exports);
__exportStar(require("./interfaces"), exports);
__exportStar(require("./conversion"), exports);
// kept for backwards compatability with v1
exports.default = index_1.tinycolor;



//////////////////
// WEBPACK FOOTER
// ./~/@ctrl/tinycolor/dist/public_api.js
// module id = 234
// module chunks = 0